export default __webpack_public_path__ + "static/media/auditoria.8dcf6f8a.svg";